module.exports = __webpack_public_path__ + "img/marc_schoenauer_rounded_gray.74b8bd67.jpg";